module.exports = __webpack_public_path__ + "static/q18_o-4aefbc780cb023a87b6a38f01d52f37b.png";